import React from "react";
import { Trash2 } from "lucide-react";

const input = "w-full border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-accent-blue focus:outline-none";

export const QaQuestionEditor = ({ q, index, docs, onChange, onDelete }) => (
  <li className="border border-slate-200 bg-white p-5" data-testid={`qa-question-${index}`}>
    <div className="flex items-start justify-between gap-3">
      <span className="font-mono text-xs text-slate-400">P{String(index + 1).padStart(2, "0")}</span>
      <button
        onClick={onDelete}
        className="text-slate-400 transition-colors hover:text-red-600"
        aria-label="Eliminar pregunta"
        data-testid={`qa-question-delete-${index}`}
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
    <label className="mt-2 block text-[10px] uppercase tracking-[0.18em] text-slate-500">Pregunta</label>
    <textarea
      rows={2}
      value={q.question}
      onChange={(e) => onChange({ ...q, question: e.target.value })}
      className={`${input} mt-1 resize-y`}
      data-testid={`qa-question-text-${index}`}
    />
    <div className="mt-3 grid gap-3 md:grid-cols-[1fr_280px]">
      <div>
        <label className="block text-[10px] uppercase tracking-[0.18em] text-slate-500">
          Datos clave esperados (separados por coma)
        </label>
        <input
          value={q.expected_facts.join(", ")}
          onChange={(e) => onChange({ ...q, expected_facts: e.target.value.split(",").map((f) => f.trimStart()) })}
          className={`${input} mt-1`}
          data-testid={`qa-question-facts-${index}`}
        />
      </div>
      <div>
        <label className="block text-[10px] uppercase tracking-[0.18em] text-slate-500">Documento fuente</label>
        <select
          value={q.source_doc || ""}
          onChange={(e) => onChange({ ...q, source_doc: e.target.value })}
          className={`${input} mt-1`}
          data-testid={`qa-question-source-${index}`}
        >
          <option value="">Cualquiera del departamento</option>
          {docs.map((d) => (
            <option key={d} value={d}>{d.replace(/\.txt$/, "")}</option>
          ))}
        </select>
      </div>
    </div>
  </li>
);
